import React, { useRef, useState, useEffect } from "react";
import { logResponse } from "../utils/logger";
import { fetchUpdatePassword } from "../api";
import SubmitButton from "../components/SubmitButton";

const UpdatePassword = () => {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);
  const isSubmittingRef = useRef(false);

  useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    if (storedEmail) {
      setEmail(storedEmail);
    }
  }, []);

  const isValidPassword = (value) => /^[a-zA-Z0-9]{8,}$/.test(value);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;
    setIsSubmitting(true);
    setErrorMessage("");
    setSuccessMessage("");
    setErrors({});

    const formData = new FormData(formRef.current);
    const password = formData.get("password")?.trim();
    const passwordConfirm = formData.get("password-confirm")?.trim();
    const access_token = localStorage.getItem("access_token");

    const newErrors = {};
    if (!password || !isValidPassword(password)) {
      newErrors.password = "半角英数字8文字以上で入力してください";
    }
    if (!passwordConfirm || !isValidPassword(passwordConfirm)) {
      newErrors.passwordConfirm = "半角英数字8文字以上で再入力してください";
    }
    if (password && passwordConfirm && password !== passwordConfirm) {
      newErrors.passwordConfirm = "パスワードが一致しません";
    }
    if (!access_token) {
      setErrorMessage("アクセストークンが見つかりません。ログイン状態をご確認ください。");
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      isSubmittingRef.current = false;
      setIsSubmitting(false);
      return;
    }

    try {
      const data = { password };
      const res = await fetchUpdatePassword(access_token, data);
      logResponse("token:", access_token);
      logResponse("req:", data);
      logResponse("res:", res);
      if (res?.detail) {
        setErrorMessage(`変更に失敗しました：${res.detail}`);
      } else {
        setSuccessMessage(
          <p>
            パスワードの変更が完了しました。<br />
            次回ログイン時は変更後のパスワードをご利用ください。
          </p>
        );
      }
    } catch (err) {
      console.error("API呼び出しエラー:", err);
      setErrorMessage("通信エラーが発生しました。時間を置いて再度お試しください。");
    } finally {
      isSubmittingRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <section className="section form-section section-block">
      <form ref={formRef} onSubmit={handleSubmit}>
        <p className="comment mb20">
          <span className="bold">{email || "（メールアドレス未取得）"}</span> のパスワードを変更します
        </p>

        <div className="form-group">
          <label htmlFor="password">新しいパスワード</label>
          <div className="group-2 password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              required
              autoComplete="current-password"
              aria-describedby="password-error"
              placeholder="半角英数字"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPassword((prev) => !prev)}
              aria-label={showPassword ? "パスワードを隠す" : "パスワードを表示する"}
            >
              <i className={`fa-solid ${showPassword ? "fa-eye" : "fa-eye-slash"}`}></i>
            </button>
            {errors.password && <div className="error">{errors.password}</div>}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="password-confirm">新しいパスワード（再入力）</label>
          <div className="group-2 password-wrapper">
            <input
              type={showPasswordConfirm ? "text" : "password"}
              name="password-confirm"
              required
              autoComplete="current-password"
              aria-describedby="password-error"
              placeholder="半角英数字"
            />
            <button
              type="button"
              className="toggle-password"
              onClick={() => setShowPasswordConfirm((prev) => !prev)}
              aria-label={showPasswordConfirm ? "パスワードを隠す" : "パスワードを表示する"}
            >
              <i className={`fa-solid ${showPasswordConfirm ? "fa-eye" : "fa-eye-slash"}`}></i>
            </button>
            {errors.passwordConfirm && <div className="error">{errors.passwordConfirm}</div>}
          </div>
        </div>

        {errorMessage && (
          <div className="error-message" style={{ color: "red", fontWeight: "bold", marginBottom: "1em" }}>
            {errorMessage}
          </div>
        )}

        {successMessage && (
          <div className="success-message" style={{ color: "green", fontWeight: "bold", marginBottom: "1em" }}>
            {successMessage}
          </div>
        )}

        <div className="btn-green mb0">
          <SubmitButton
            isSubmitting={isSubmitting}
            label="パスワードを変更する"
            className="btn-green"
            wrap={false}
          />
        </div>
      </form>
    </section>
  );
};

export default UpdatePassword;
